import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import { ApolloProvider } from '@apollo/client';
import client from './util/ApolloProvider';
import { GeneralContext, GeneralStore } from './util/Store';
import { ThemeStore, ThemeContext } from './util/ThemeStore';
import App from './App';

const generalStore = new GeneralStore();
const themeStore = new ThemeStore();

Sentry.init({
  dsn: 'https://75451bb508a2f626fe87c0a289cd35ae@o4505790970265600.ingest.sentry.io/4505790972362752',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <GeneralContext.Provider value={generalStore}>
        <ThemeContext.Provider value={themeStore}>
          <App />
        </ThemeContext.Provider>
      </GeneralContext.Provider>
    </ApolloProvider>
  </React.StrictMode>,
);
